//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import CustomerStatement from '../../graphql/entities/customer/CustomerStatement';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';

const { formUrl, type, title, workspace } = CustomerStatement;

const CUSTOMER_STATEMENT_RESULT_FIELD_NAMES = [
  'customer.reference',
  'customer.name',
  'currentFinancialPeriodName',
  'numberOfTransactions',
  'outstandingBalance',
];

const CustomerStatementResultWorkspace = (props) => {
  const workspaceProps = useWorkspace(props, CustomerStatement, { columns: CUSTOMER_STATEMENT_RESULT_FIELD_NAMES });

  return (
    <Workspace
      entityType={type}
      initialSortColumn="customer.id"
      form={CUSTOMER_STATEMENT_RESULT_FIELD_NAMES}
      formUrl={formUrl}
      title={title}
      defaultQuery={workspace}
      entity={CustomerStatement}
      {...workspaceProps}
      {...props}
    />
  );
};

export default CustomerStatementResultWorkspace;
